<template>
  <v-app>
    <v-container class="pa-6 ma-0 d-flex flex-column gap-6 align-center main-d">
      <!-- section 1 -->
      <v-container class="pa-0 ma-0">
        <SalesFilter
          @apply-filters="HandleApplyFilters"
          @apply-advanced-filters="HandleApplyAdvancedFilters"
        />
        <OverviewCards
          v-if="profitData && sellData && invoiceData && warehouseData"
          :profit-data="profitData"
          :sell-data="sellData"
          :invoice-data="invoiceData"
          :warehouse-data="warehouseData"
          :duration="changeDurationText"
        />
      </v-container>
      <!--section 2 -->
      <v-container fluid class="pa-0 ma-0">
        <v-row dense>
          <!--sell progress -->
          <v-col cols="12" md="6">
            <AreaProgressSellChart
              :filter-chart="filter"
              :advance-filter="advancefilter"
            />
          </v-col>
          <!-- profit progress-->
          <v-col cols="12" md="6">
            <AreaProgressProfitChart
              :filter-chart="filter"
              :advance-filter="advancefilter"
            />
          </v-col>
        </v-row>
      </v-container>
      <!--section 3 -->
      <v-container fluid class="pa-0 ma-0">
        <v-row dense>
          <!-- BestSellingProducts-->
          <v-col cols="12" md="6">
            <BestSellingProducts :filter-chart="filter" :advance-filter="advancefilter" />
          </v-col>
          <!--the most profit products -->
          <v-col cols="12" md="6">
            <MostProfitProducts :filter-chart="filter" :advance-filter="advancefilter" />
          </v-col>
        </v-row>
      </v-container>
      <!--section 4 -->
      <v-container fluid class="pa-0 ma-0">
        <v-row dense>
          <!-- compare sales and profits-->
          <v-col cols="12" md="6">
            <ComparisonSalesProfit
              :filter-chart="filter"
              :advance-filter="advancefilter"
            />
          </v-col>
          <!--product category -->
          <v-col cols="12" md="6">
            <ProductCategory :filter-chart="filter" :advance-filter="advancefilter" />
          </v-col>
        </v-row>
      </v-container>
      <!-- section 5-->
      <v-container class="pa-0 ma-0">
        <SalesByCustomer :filter-chart="filter" :advance-filter="advancefilter" />
      </v-container>
      <!-- section 6 -->
      <v-container class="pa-0 ma-0">
        <ProfitRateOnSales :filter-chart="filter" :advance-filter="advancefilter" />
      </v-container>
    </v-container>
  </v-app>
</template>

<script>
import AreaProgressSellChart from "./partial/AreaProgressSellChart.vue";
import AreaProgressProfitChart from "./partial/AreaProgressProfitChart.vue";
import MostProfitProducts from "./partial/MostProfitProducts.vue";
import BestSellingProducts from "./partial/BestSellingProducts.vue";
import ProfitRateOnSales from "./partial/ProfitRateOnSales.vue";
import ComparisonSalesProfit from "./partial/ComparisonSalesProfit.vue";
import ProductCategory from "./partial/ProductCategory.vue";
import SalesByCustomer from "./partial/SalesByCustomer.vue";
import SalesFilter from "./partial/SalesFilter.vue";
import OverviewCards from "./partial/OverviewCards.vue";

export default {
  name: "sell",
  components: {
    AreaProgressSellChart,
    AreaProgressProfitChart,
    MostProfitProducts,
    BestSellingProducts,
    ProfitRateOnSales,
    ComparisonSalesProfit,
    ProductCategory,
    SalesByCustomer,
    SalesFilter,
    OverviewCards,
  },
  data: () => ({
    sellData: null,
    profitData: null,
    warehouseData: null,
    PurchaseData: null,
    crmData: null,
    CostData: null,
    invoiceData: null,
    loading: false,
    filter: null,
    advancefilter: null,
    changeDurationText: false,
  }),
  mounted() {
    this.getSellData();
  },
  methods: {
    HandleApplyFilters(filters) {
      this.filter = filters;
      this.getSellData(filters);
    },
    HandleApplyAdvancedFilters(filters) {
      this.advancefilter = filters;
      this.getSellData(filters);
    },
    getSellData(filters = {}) {
      const hasDefaultDate = !!filters.fromDate && !!filters.toDate;
      const Type = hasDefaultDate ? false : "month";
      let UserList = [];
      let ProductList = [];
      if (
        filters.UserList != undefined &&
        filters.UserList != null &&
        filters.UserList != []
      ) {
        UserList = filters?.UserList.map((u) => u.id);
      }
      if (
        filters.products != undefined &&
        filters.products != null &&
        filters.products != []
      ) {
        ProductList = filters?.products.map((p) => p.id);
      }
      // const UserList = filters?.UserList.map((u) => u.id);
      // const ProductList = filters?.products.map((p) => p.id);
      var app = this;
      app.loading = true;
      this.$axios
        .get(this.$endpoint + "dashboard/invoice-kpi", {
          params: {
            dateType: Type,
            fromDate: filters.fromDate || null,
            toDate: filters.toDate || null,
            status: filters.sellStatus || [],
            accountIds: filters.account || [],
            branch: filters.branch || [],
            UserList: UserList || [],
            minAmount: filters.amountRange?.[0] ?? null,
            maxAmount: filters.amountRange?.[1] ?? null,
            ProductList: ProductList || [],
            productGroup: filters.productGroup || null,
            entrepot: filters.entrepot || null,
            attachment: filters.attachments || null,
            receipt: filters.Receipt || null,
            category: filters.category || null,
            minAmountTax: filters.amountRangeTax?.[0] ?? null,
            maxAmountTax: filters.amountRangeTax?.[1] ?? null,
            invoice_status: filters.status || null,
          },
        })
        .then((response) => {
          let res = response.data;
          app.sellData = res.sumSell;
          app.profitData = res.totalProfit;
          app.invoiceData = res.invoiceSum;
          app.warehouseData = res.EntrepotSummary;
          app.changeDurationText = res.flag;
        })
        .catch((err) => {
          app.loading = false;
        })
        .finally(() => {
          app.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.main-d {
  min-width: 400px !important;
}
</style>
